import { gql } from 'apollo-boost';

export class SettingsService {
	constructor(graphqlClient, backEndAxios, restAxios) {
		this.graphqlClient = graphqlClient;
		this.backEndAxios = backEndAxios;
		this.restAxios = restAxios;
		this.apiVersion = 'v2';
	}

	async getSerenityEventsSettings() {
		const serenityEventsSettingsResponse = await this.graphqlClient.query({
			query: gql`
        query serenityEventsSettings {
          serenityEventsSettings {
            serenitySalesEmail
            serenitySupportEmail
            serenityMarketingSite
          }
        }
      `,
			fetchPolicy: 'no-cache',
		});

		return serenityEventsSettingsResponse.data.serenityEventsSettings;
	}

	async sendSerenityRequestEmail(userId, machineSerialNumber = '') {
		const sendSerenityRequestEmailResponse = await this.graphqlClient.query({
			query: gql`
        query ($userId: String!, $machineSerialNumber: String) {
          sendSerenityRequestEmail(userId: $userId, machineSerialNumber: $machineSerialNumber)
        }
      `,
			variables: {
				userId: userId,
				machineSerialNumber: machineSerialNumber,
			},
			fetchPolicy: 'no-cache',
		});

		return sendSerenityRequestEmailResponse.data.sendSerenityRequestEmail;
	}

	getDistributionLinks = () => {
		return Promise.all([
			this.backEndAxios.get(`/centralBackend/${this.apiVersion}/product/getProductDistributionLinks`),
			this.restAxios.get(`/system/settings/os6-common`)
		])
			.then(([responseDistributionLinks, responseOs6DistributionLinks]) => {
				return Object.assign({}, responseDistributionLinks?.data?.distributionLinks, responseOs6DistributionLinks?.data) ?? [];
			})
			.catch((error) => {
				throw error?.response?.data?.detail ?? 'Failed to fetch distribution links...';
			});
	};

	// Empty string means "no link configured yet": callers hide their Learn More link instead of
	// rendering a dead one.
	getPartnerPreviewLearnMoreUrl = () => {
		return this.restAxios.get('/system/settings/preview-program')
			.then((response) => {
				return response.data?.partnerPreviewLearnMoreUrl ?? '';
			});
	};

	async getRenewalsSettings() {
		const renewalsSettingsResponse = await this.graphqlClient.query({
			query: gql`
        query {
          renewalsSettings {
            expiringIntervalSettingForCustomer
          }
        }
      `,
			fetchPolicy: 'no-cache',
		});

		return renewalsSettingsResponse.data.renewalsSettings;
	}
}
